import { render, staticRenderFns } from "./CustomRightDrawer.vue?vue&type=template&id=6f581cee"
import script from "./CustomRightDrawer.vue?vue&type=script&lang=js"
export * from "./CustomRightDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports